export default "__VITE_ASSET__a6849213__"